module.exports = __webpack_public_path__ + "img/icon-3.cff5c6e0.png";